import React from 'react';
import { shape, string, arrayOf, number } from 'prop-types';
import classNames from 'classnames/bind';

import { Image } from '@thd-olt-component-react/core-ui';

import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import styles from './MobileCategoryTab.module.scss';

const cNames = classNames.bind(styles);

const MobileCategoryTab = ({ category, numCategories }) => {
  const { specialBuyEndpoint } = useSpecialBuy();
  const { categoryId, name, products } = category;

  const numImagesInTab = numCategories === 1 ? 3 : 1;
  const imageSrcs = products.slice(0, numImagesInTab).map(({ image }) => image);

  return (
    <a
      href={`${specialBuyEndpoint}#${categoryId}`}
      className={cNames('category-tab')}
    >
      <div className={cNames('category-tab__images')}>
        {imageSrcs.map((src, i) => (
          <Image
            alt=""
            src={src}
            key={`category-image-${i}`}
            className={cNames('category-tab__image')}
            width={1}
            height={1}
          />
        ))}
      </div>
      {numCategories > 1 && (
        <span className={cNames('category-tab__text')}>{name} ({products.length})</span>
      )}
    </a>
  );
};

MobileCategoryTab.propTypes = {
  category: shape({
    name: string.isRequired,
    products: arrayOf(shape({ image: string.isRequired })),
    categoryId: string,
  }).isRequired,
  numCategories: number.isRequired,
};

export { MobileCategoryTab };
